export function findTextGuidInObject(
  object: { parent: unknown; userData: Record<string, unknown> } | null
): string | undefined {
  let current: typeof object = object;
  while (current) {
    const guid = current.userData['textGuid'];
    if (typeof guid === 'string') {
      return guid;
    }
    current = current.parent as typeof object;
  }
  return undefined;
}

export function collectTextGuidsFromObjectIds(
  root: { getObjectById(id: number): unknown },
  objectIds: readonly number[]
): string[] {
  const guids: string[] = [];
  const seen = new Set<string>();
  for (const id of objectIds) {
    const object = root.getObjectById(id) as {
      parent: unknown;
      userData: Record<string, unknown>;
    } | null;
    const guid = findTextGuidInObject(object);
    if (guid && !seen.has(guid)) {
      seen.add(guid);
      guids.push(guid);
    }
  }
  return guids;
}

export function areTextGuidSelectionsEqual(
  left: readonly string[],
  right: readonly string[]
): boolean {
  if (left.length !== right.length) {
    return false;
  }

  const counts = new Map<string, number>();
  for (const guid of left) {
    counts.set(guid, (counts.get(guid) ?? 0) + 1);
  }
  for (const guid of right) {
    const remaining = counts.get(guid);
    if (!remaining) {
      return false;
    }
    if (remaining === 1) {
      counts.delete(guid);
    } else {
      counts.set(guid, remaining - 1);
    }
  }
  return counts.size === 0;
}
